import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../shared/services/common.service';
import {ApplicationCategory, FacilityCategory, FacilityType, FeeInfo, RegionType,   
  MLevel,MRLevel, 
  ProductType} from '../../models/CommonModels';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ChecklistConfigModel, ChecklistModel} from '../../models/ChecklistModel';
import {SettingsService} from '../../shared/services/settings.service';
import {DocumentConfigModel, DocumentModel} from '../../models/DocumentModel';
import {AlertService} from '../../shared/services/alert.service';
import { ChangeType } from '../../models/ApplicationDetail';
import * as Constants from '../../models/Constants';

@Component({
  selector: 'app-checklist-config',
  templateUrl: './module-config.component.html',
  styleUrls: ['./module-config.component.css']
})
export class ModuleConfigComponent implements OnInit {
  public applicationCategories: ApplicationCategory[];
  public facilityCategories: FacilityCategory[];
  public regions: RegionType[];
  public facilityTypes: FacilityType[];
  public productTypes: ProductType[];
  public checklists: ChecklistModel[];
  public documents: DocumentModel[];
  public changeTypes: ChangeType[]
  public selectedProductTypeId: number;
  public selectedChangeTypeRefId: number;
  public selectedFacilityTypeId: number;
  public selectedFacilityCategoryId: number;
  public selectedApplicationCategoryId: number;
  public disableChecklistTab: boolean;
  public disableFeeTab: boolean;
  public constants: any = Constants;
  modalRef: BsModalRef;
  requiredChecklists: number[];
  activeChecklists: number[];
  requiredDocuments: number[];
  activeDocuments: number[];
  checklistConfigList: ChecklistConfigModel[];
  documentConfigList: DocumentConfigModel[];
  activeTab: string;
  configuredFeeForSelection: FeeInfo;
  configuredFeeForWithinRegionSelection: FeeInfo;
  public manufacturingLevels: MLevel[];
  public manufacturingRiskLevels: MRLevel[];
  public selectedManuLevelId: number;
  public selectedManuRiskLevelId: number;

  constructor(private commonService: CommonService, private settingsService: SettingsService, private modalSerivce: BsModalService,
              private alertService: AlertService) { }

  ngOnInit() {
    this.activeChecklists = [];
    this.requiredChecklists = [];
    this.activeDocuments = [];
    this.requiredDocuments = [];
    this.getApplicationCategories();
    this.getmLevels();
    this.getmRLevels();
    this.getChecklists();
    this.getDocuments();
    this.activeTab = 'Checklists';

    (<any>jQuery('#metismenu')).metisMenu();
    $(document).ready(function(){
      $('.i-checks').iCheck({ checkboxClass: 'icheckbox_square-green'});
      $('.i-checks').on('ifToggled', event => {
      });
    });
  }

  isActiveTab(tabLabel) {
    return this.activeTab === tabLabel;
  }

  tabSelected(tabLabel) {
    this.activeTab = tabLabel;
  }

  makeChecklistAndFeeInactive(){
    this.disableChecklistTab = true;
    this.disableFeeTab = true;
  }

  activateChecklistAndFee(){
    this.disableChecklistTab = false;
    this.disableFeeTab = false;
  }

  getChecklists() {
    this.settingsService.getAllChecklists().subscribe(res => {
      this.checklists = res;
    });
  }

  getDocuments() {
    this.settingsService.getAllDocuments().subscribe(res => {
      this.documents = res;
    });
  }

  getFacilityTypes(): void {
    this.facilityTypes = [];
    this.commonService.getFacilityTypes(true).subscribe(facilityTypes => {
      if (facilityTypes && facilityTypes.length) {
        // select the first facility type to be displayed on load
        facilityTypes.forEach(facilityType => {
          this.commonService.getProductTypes(facilityType.id).subscribe(productTypes => {
            if (productTypes && productTypes.length) {
              facilityType.productTypes = productTypes;
              this.facilityTypes.push(facilityType);
            }

            const _this = this;
            this.applicationCategories.forEach(function (appCat) {

              if([Constants.APPLICATION_TYPE_CODE_CHANGE].indexOf( appCat.applicationCategoryCode) !== -1){
                  productTypes.forEach(ProductType =>{
                  _this.commonService.getChangeTypesByFacilityAndProductType(facilityType.id,ProductType.id, appCat.applicationCategoryCode).subscribe(changeTypes => {
                    if(changeTypes && changeTypes.length){
                      ProductType.changeTypes = changeTypes;
                    }

                    if(facilityType.name == Constants.MANUFACTURER && ProductType.name == Constants.PRODUCT_TYPE_FOOD){
                      ProductType.manufacturingLevels = _this.manufacturingLevels;
                      ProductType.manufacturingLevels.forEach(manuLevel => {
                        if(manuLevel.name == Constants.HIGHER_MANUFACTURING_NAME)
                        {
                          manuLevel.manufacturingRiskLevels = _this.manufacturingRiskLevels.filter(mr => mr.name != Constants.MEDIUM_RISK_LEVEL_FOOD_NAME);
                        }else {
                          manuLevel.manufacturingRiskLevels = _this.manufacturingRiskLevels.filter(
                            mr => mr.name == Constants.HIGH_RISK_LEVEL_FOOD_NAME || mr.name == Constants.LOW_RISK_LEVEL_FOOD_NAME);
                        }
                      });
                    } 
                  });
                });
              }

              if ([Constants.APPLICATION_TYPE_CODE_TEMP_COC,Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE,
                  Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE].indexOf(appCat.applicationCategoryCode) !== -1) {
                // get product type for Temp COC again               
                appCat.facilityTypes = new Array();
                _this.facilityTypes.forEach(ft => {
                  if(ft.name === Constants.MANUFACTURER || ft.name === Constants.IMPORTER || ft.name === Constants.WHOLESALER)
                  {
                    appCat.facilityTypes.push(Object.assign(new FacilityType(), ft));
                  }               
                });
                
                appCat.facilityTypes.forEach(ft => {
                  _this.commonService.getProductTypes(ft.id, true).subscribe(ptypes => {
                    ft.productTypes = ptypes.filter(pt => pt.name.indexOf('Med') > -1 ||
                           pt.name.indexOf(Constants.PROUDCT_TYPE_BARRIER_FACE_MASK) > -1);
                    ft.productTypes.forEach(ProductType =>{
                      _this.commonService.getChangeTypesByFacilityAndProductType(ft.id,ProductType.id, appCat.applicationCategoryCode).subscribe(changeTypes => {
                        if(changeTypes && changeTypes.length){
                          ProductType.changeTypes = changeTypes;
                        }
                      });
                    });
                  });                 
                });
              } else if(appCat.applicationCategoryCode !== Constants.APPLICATION_TYPE_CODE_RENEWAL){
                appCat.facilityTypes = _this.facilityTypes;
              }

            });
            this.facilityCategories.forEach(function (facilityCategory) {
                facilityCategory.facilityTypes = _this.facilityTypes;
            });
          });
        });
      }
    });
  }

  getApplicationCategories() {
    this.applicationCategories = [];
    this.commonService.getApplicationCategories().subscribe(appCategories => {
      this.applicationCategories = [];
      const _this = this;
      appCategories.forEach(function (appCat) {
      
          _this.applicationCategories.push(appCat);
      
      })
        this.getFacilityCategories();
        this.getFacilityTypes();
        this.getRegions();
    },
      err => {
      console.log('Error fetching application categories');
      });
  }

  getFacilityCategories() {
    this.facilityCategories = [];

    const facilityCategory = new FacilityCategory();
    const facilityCategory2 = new FacilityCategory();
    const facilityCategory3 = new FacilityCategory();
    facilityCategory.name = 'Green';
    facilityCategory.id = 1;
    this.facilityCategories.push(facilityCategory);
    facilityCategory2.name = 'Yellow';
    facilityCategory2.id = 2;
    this.facilityCategories.push(facilityCategory2);
    facilityCategory3.name = 'Red';
    facilityCategory3.id = 3;
    this.facilityCategories.push(facilityCategory3);

    const _this = this;
    this.applicationCategories.forEach(function (appCat) {
      if (appCat.name === 'Renewal') {
        appCat.facilityCategories = _this.facilityCategories;
      }
    });
  }


  getRegions() {
    this.regions = [];

    const _this = this;
    this.commonService.getRegionTypes().subscribe(regions => {
        this.regions = regions;
        this.applicationCategories.forEach(function (appCat) {
          if (appCat.name === 'Renewal') {
            appCat.facilityCategories = _this.facilityCategories;
          }
        });
      },
      err => {
        console.log('Error fetching application categories');
      });
  }

  navMenuClicked(value) {
    value.isExpanded = !value.isExpanded;
  }

  displayConfigForSelection(facilityType, productType, applicationCategory, facilityCategory, changeType, manuLevel, manuRiskLevel) {
    if (applicationCategory && [Constants.APPLICATION_TYPE_CODE_TEMP_COC, Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE].indexOf(
      applicationCategory.applicationCategoryCode) !== -1) {
      this.makeChecklistAndFeeInactive();
    } else {
      this.activateChecklistAndFee();
    }
    
    if(applicationCategory && [Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE].indexOf( applicationCategory.applicationCategoryCode) !== -1){
      this.disableChecklistTab = true;
    }
    
    this.activeChecklists = [];
    this.requiredChecklists = [];
    this.activeDocuments = [];
    this.requiredDocuments = [];
    this.selectedFacilityTypeId = facilityType.id;
    this.selectedProductTypeId = productType.id;
    this.selectedApplicationCategoryId = applicationCategory.id;
    this.selectedChangeTypeRefId = changeType ? changeType.changeTypeRefID : null;
    this.selectedFacilityCategoryId = facilityCategory? facilityCategory.id : null;
    this.selectedManuLevelId = manuLevel ? manuLevel.id : null;
    this.selectedManuRiskLevelId = manuRiskLevel ? manuRiskLevel.id : null;
    console.log('facilityTypeId: ' + facilityType.id + ' productTypeId: ' + productType.id);
    this.getChecklistSpecForSelection(facilityType, productType, applicationCategory, facilityCategory,changeType);
    this.getDocSpecForSelection(facilityType, productType, applicationCategory, facilityCategory, changeType, manuLevel, manuRiskLevel);
    this.getConfiguredFeeForWithinRegionSelection(facilityType, productType, applicationCategory, facilityCategory, changeType);
    this.getConfiguredFeeForOutsideRegionSelection(facilityType, productType, applicationCategory, facilityCategory, changeType);
  }

  private getConfiguredFeeForWithinRegionSelection(facilityType, productType, applicationCategory, facilityCategory, changeType) {
    this.settingsService.getFeeInfoForSelection(facilityType.id, productType.id, applicationCategory.id,
      facilityCategory ? facilityCategory.id : null, changeType ? changeType.changeTypeRefID : null, true).subscribe(
      res => {
        this.configuredFeeForWithinRegionSelection = res;
      },
      err => {
        console.log('Error fetching fee info');
      }
    );
  }

  private getConfiguredFeeForOutsideRegionSelection(facilityType, productType, applicationCategory, facilityCategory, changeType) {
    this.settingsService.getFeeInfoForSelection(facilityType.id, productType.id, applicationCategory.id,
      facilityCategory ? facilityCategory.id : null, changeType ? changeType.changeTypeRefID : null, false).subscribe(
      res => {
        this.configuredFeeForSelection = res;
      },
      err => {
        console.log('Error fetching fee info');
      }
    );
  }

  private getDocSpecForSelection(facilityType, productType, applicationCategory, facilityCategory, changeType, manuLevel, manuRiskLevel) {
    this.settingsService.getDocConfigForFacilityTypeProductTypeAppCategoryAndChangeType(facilityType.id, productType.id,
      applicationCategory.id, facilityCategory ? facilityCategory.id : null, changeType ? changeType.changeTypeRefID : null,
      manuLevel ? manuLevel.id : null, manuRiskLevel ? manuRiskLevel.id :null ).subscribe(
      res => {
        this.documentConfigList = res;

        res.forEach(docConfig => {
          if (docConfig.active) {
            this.activeDocuments.push(docConfig.documentReferenceID);
          }
          if (docConfig.required) {
            this.requiredDocuments.push(docConfig.documentReferenceID);
          }
        });
      },
      err => {
        console.log('Error fetching doc config');
      }
    );
  }

  private getChecklistSpecForSelection(facilityType, productType, applicationCategory, facilityCategory,changeType) {
    this.settingsService.getChecklistConfigForFacilityTypeProductTypeAppCategoryAndFacilityCategory(facilityType.id, productType.id,
      applicationCategory.id, facilityCategory ? facilityCategory.id : null, changeType ? changeType.changeTypeRefID : null).subscribe(
      res => {
        this.checklistConfigList = res;
        if (res) {
          res.forEach(checklistConfig => {
            if (checklistConfig.active) {
              this.activeChecklists.push(checklistConfig.checklistID);
            }
            if (checklistConfig.required) {
              this.requiredChecklists.push(checklistConfig.checklistID);
            }
          });
        }
      },
      err => {
        console.log('Error fetching checklist config');
      }
    );
  }

  isActive(facilityTypeId, productTypeId, applicationCategoryId, facilityCategoryId,changeTypeRefId, manuLevelId, manuRiskLevelId) {
    // TODO: handle when facilityCategoryId is null
      return this.selectedFacilityTypeId === facilityTypeId &&
      this.selectedProductTypeId === productTypeId &&
      this.selectedApplicationCategoryId === applicationCategoryId &&
      this.selectedChangeTypeRefId === changeTypeRefId &&
      this.selectedManuLevelId == manuLevelId &&
      this.selectedManuRiskLevelId == manuRiskLevelId;
  }

  checklistIsActive(checklist) {
    return this.activeChecklists.indexOf(checklist.id) > -1;
  }

  checklistIsRequired(checklist) {
    return this.requiredChecklists.indexOf(checklist.id) > -1;
  }

  addButtonClicked(checklistTemplate, documentTemplate) {
    if (this.activeTab === 'Checklists') {
      this.modalRef = this.modalSerivce.show(checklistTemplate, {backdrop: 'static', keyboard: false});
    }else {
      this.modalRef = this.modalSerivce.show(documentTemplate, {backdrop: 'static', keyboard: false});
    }
  }

  addChecklist(name, descr) {
    let checklist = new ChecklistModel();
    checklist.name = name.value;
    checklist.description = descr.value;
    this.settingsService.addChecklist(checklist).subscribe(
      res => {
          if (res) {
            this.alertService.success('Checklist Added successfully');
            this.getChecklists();
          }else {
            this.alertService.error('Adding checklist failed');
          }
      },
      error => {
          console.log('error creating checklist');
        this.alertService.error('Adding checklist failed');
      },
      () => {
        this.modalRef.hide();
      });
  }

  addDocument(name, descr) {
    let documentModel = new DocumentModel();
    documentModel.name = name.value;
    documentModel.description = descr.value;
    documentModel.plcDocument = false;
    documentModel.focalPersonDocument = false;
    this.settingsService.addDoc(documentModel).subscribe(
      res => {
          if (res) {
            this.alertService.success('Document Added successfully');
            this.getDocuments();
          }else {
            this.alertService.error('Adding document failed');
          }
      },
      error => {
          console.log('error creating document');
        this.alertService.error('Adding document failed');
      },
      () => {
        this.modalRef.hide();
      });
  }


  requiredChecklistClicked(checklist) {
    const index = this.requiredChecklists.indexOf(checklist.id);
    const activeIndex = this.activeChecklists.indexOf(checklist.id);
    if (index > -1) {
      this.requiredChecklists.splice(index, 1);
      const chkCnfg = this.checklistConfigList.filter(chkCnfg => chkCnfg.checklistID === checklist.id)[0];
      chkCnfg.required = false;
      this.settingsService.updateChecklistConfig(chkCnfg).subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log(err);
        }
      );
    } else if(activeIndex > -1){
      this.requiredChecklists.push(checklist.id);
      const chkCnfg = this.checklistConfigList.filter(chkCnfg => chkCnfg.checklistID === checklist.id)[0];
      chkCnfg.required = true;
      this.settingsService.updateChecklistConfig(chkCnfg).subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log(err);
        }
      );
    }else {
      this.requiredChecklists.push(checklist.id);
      this.activeChecklists.push(checklist.id);
      let checklistConfig = new ChecklistConfigModel();
      checklistConfig.active = true;
      checklistConfig.required = true;
      checklistConfig.checklistID = checklist.id;
      checklistConfig.changeTypeRefID = this.selectedChangeTypeRefId;
      checklistConfig.facilityTypeID = this.selectedFacilityTypeId;
      checklistConfig.itemTypeID = this.selectedProductTypeId;
      checklistConfig.applicationCategoryID = this.selectedApplicationCategoryId;
      checklistConfig.facilityCategoryID = this.selectedFacilityCategoryId;
      this.settingsService.addChecklistConfig(checklistConfig).subscribe(
        res => {
          this.settingsService.getChecklistConfigForFacilityTypeProductTypeAppCategoryAndFacilityCategory(checklistConfig.facilityTypeID,
            checklistConfig.itemTypeID, checklistConfig.applicationCategoryID, checklistConfig.facilityCategoryID,checklistConfig.changeTypeRefID)
            .subscribe(
            res => {
              this.checklistConfigList = res;
            },
            err => {
              console.log('Error fetching checklist config');
            }
          );
          console.log (res);
        },
        error => {
          console.log (error);
        }
      );
    }
  }

  activeChecklistClicked(checklist) {
    const index = this.activeChecklists.indexOf(checklist.id);
    const requiredIndex = this.requiredChecklists.indexOf(checklist.id);
    if (index > -1) {
      this.activeChecklists.splice(index, 1);
      if (requiredIndex > -1) {
        this.requiredChecklists.splice(requiredIndex, 1);
      }
      const chkCnfg = this.checklistConfigList.filter(chkCnfg => chkCnfg.checklistID === checklist.id)[0];
      this.settingsService.removeChecklistConfig(chkCnfg).subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log(err);
        }
      );
    }else {
      this.activeChecklists.push(checklist.id);
      let checklistConfig = new ChecklistConfigModel();
      checklistConfig.active = true;
      checklistConfig.checklistID = checklist.id;
      checklistConfig.changeTypeRefID = this.selectedChangeTypeRefId;
      checklistConfig.facilityTypeID = this.selectedFacilityTypeId;
      checklistConfig.itemTypeID = this.selectedProductTypeId;
      checklistConfig.applicationCategoryID = this.selectedApplicationCategoryId;
      checklistConfig.facilityCategoryID = this.selectedFacilityCategoryId;
      this.settingsService.addChecklistConfig(checklistConfig).subscribe(
        res => {
          this.settingsService.getChecklistConfigForFacilityTypeProductTypeAppCategoryAndFacilityCategory(checklistConfig.facilityTypeID,
            checklistConfig.itemTypeID, checklistConfig.applicationCategoryID, checklistConfig.facilityCategoryID,checklistConfig.changeTypeRefID)
            .subscribe(
            res => {
              this.checklistConfigList = res;
            },
            err => {
              console.log('Error fetching checklist config');
            }
          );
          console.log (res);
        },
        error => {
          console.log (error);
        }
      );
    }
  }

  docIsActive(doc) {
    return this.activeDocuments.indexOf(doc.id) > -1;
  }

  docIsRequired(doc) {
    return this.requiredDocuments.indexOf(doc.id) > -1;
  }

  activeDocClicked(doc) {
    const index = this.activeDocuments.indexOf(doc.id);
    const requiredIndex = this.requiredDocuments.indexOf(doc.id);
    if (index > -1) {
      this.activeDocuments.splice(index, 1);
      if (requiredIndex > -1) {
        this.requiredDocuments.splice(requiredIndex, 1);
      }
      const docCnfg = this.documentConfigList.filter(docCnfg1 => docCnfg1.documentReferenceID === doc.id)[0];
      this.settingsService.removeDocConfig(docCnfg).subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log(err);
        }
      );
    }else {
      this.activeDocuments.push(doc.id);
      let documentConfigModel = new DocumentConfigModel();
      documentConfigModel.active = true;
      documentConfigModel.documentReferenceID = doc.id;
      documentConfigModel.facilityTypeID = this.selectedFacilityTypeId;
      documentConfigModel.itemTypeID = this.selectedProductTypeId;
      documentConfigModel.applicationCategoryID = this.selectedApplicationCategoryId;
      documentConfigModel.changeTypeRefID = this.selectedChangeTypeRefId;
      documentConfigModel.facilityCategoryID = this.selectedFacilityCategoryId;
      documentConfigModel.mLevelID = this.selectedManuLevelId;
      documentConfigModel.mRLevelID = this.selectedManuRiskLevelId;
      this.settingsService.addDocConfig(documentConfigModel).subscribe(
        res => {
          this.settingsService.getDocConfigForFacilityTypeProductTypeAppCategoryAndChangeType(documentConfigModel.facilityTypeID,
            documentConfigModel.itemTypeID, documentConfigModel.applicationCategoryID, documentConfigModel.facilityCategoryID,
            documentConfigModel.changeTypeRefID, documentConfigModel.mLevelID, documentConfigModel.mRLevelID)
            .subscribe(
            res => {
              this.documentConfigList = res;
            },
            err => {
              console.log('Error fetching doc config');
            }
          );
          console.log (res);
        },
        error => {
          console.log (error);
        }
      );
    }
  }

  requiredDocClicked(doc) {
    const index = this.requiredDocuments.indexOf(doc.id);
    const activeIndex = this.activeDocuments.indexOf(doc.id);
    if (index > -1) {
      this.requiredDocuments.splice(index, 1);
      const docCnfg = this.documentConfigList.filter(docCnfg1 => docCnfg1.documentReferenceID === doc.id)[0];
      docCnfg.required = false;
      this.settingsService.updateDocConfig(docCnfg).subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log(err);
        }
      );
    } else if (activeIndex > -1) {
      this.requiredDocuments.push(doc.id);
      const docCnfg = this.documentConfigList.filter(docCnfg1 => docCnfg1.documentReferenceID === doc.id)[0];
      docCnfg.required = true;
      this.settingsService.updateDocConfig(docCnfg).subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log(err);
        }
      );
    }else {
      this.requiredDocuments.push(doc.id);
      this.activeDocuments.push(doc.id);
      let documentConfigModel = new DocumentConfigModel();
      documentConfigModel.active = true;
      documentConfigModel.required = true;
      documentConfigModel.documentReferenceID = doc.id;
      documentConfigModel.facilityTypeID = this.selectedFacilityTypeId;
      documentConfigModel.itemTypeID = this.selectedProductTypeId;
      documentConfigModel.applicationCategoryID = this.selectedApplicationCategoryId;
      documentConfigModel.changeTypeRefID = this.selectedChangeTypeRefId;
      documentConfigModel.facilityCategoryID = this.selectedFacilityCategoryId;
      documentConfigModel.mLevelID = this.selectedManuLevelId;
      documentConfigModel.mRLevelID = this.selectedManuRiskLevelId;
      this.settingsService.addDocConfig(documentConfigModel).subscribe(
        res => {
          this.settingsService.getDocConfigForFacilityTypeProductTypeAppCategoryAndChangeType(documentConfigModel.facilityTypeID,
            documentConfigModel.itemTypeID, documentConfigModel.applicationCategoryID, documentConfigModel.facilityCategoryID,
            documentConfigModel.changeTypeRefID, documentConfigModel.mLevelID, documentConfigModel.mRLevelID)
            .subscribe(
            res => {
              this.documentConfigList = res;
            },
            err => {
              console.log('Error fetching doc config');
            }
          );
          console.log (res);
        },
        error => {
          console.log (error);
        }
      );
    }
  }
  
  saveConfiguredFeeForWithinRegionSelection(fee) {
    if (!this.configuredFeeForWithinRegionSelection) {
      this.configuredFeeForWithinRegionSelection = new FeeInfo();
      this.configuredFeeForWithinRegionSelection.facilityTypeID = this.selectedFacilityTypeId;
      this.configuredFeeForWithinRegionSelection.productTypeID = this.selectedProductTypeId;
      this.configuredFeeForWithinRegionSelection.applicationCategoryID = this.selectedApplicationCategoryId;
      this.configuredFeeForWithinRegionSelection.facilityCategoryID = this.selectedFacilityCategoryId;
      this.configuredFeeForWithinRegionSelection.changeTypeRefID = this.selectedChangeTypeRefId;
      this.configuredFeeForWithinRegionSelection.withinRegion = true;
      this.configuredFeeForWithinRegionSelection.fee = fee.value;
      this.settingsService.configureFeeForSelection(this.configuredFeeForWithinRegionSelection).subscribe(
        res => {
          if (res){
            this.alertService.success('Fee info added successfully');
          }else {
            this.alertService.error('Adding Fee info failed');
          }

        }, err => {
          this.alertService.error('Adding Fee info failed');
        }
      );
    } else {
      this.configuredFeeForWithinRegionSelection.fee = fee.value;
      this.settingsService.updateFeeConfigurationForSelection(this.configuredFeeForWithinRegionSelection).subscribe(
        res => {
          if (res) {
            this.alertService.success('Fee info updated successfully');
          }else {
            this.alertService.error('Updating Fee info failed');
          }

        }, err => {
          this.alertService.error('Updating Fee info failed');
        }
      );
    }

  }

  saveConfiguredFeeForSelection(fee) {
    if (!this.configuredFeeForSelection) {
      this.configuredFeeForSelection = new FeeInfo();
      this.configuredFeeForSelection.facilityTypeID = this.selectedFacilityTypeId;
      this.configuredFeeForSelection.productTypeID = this.selectedProductTypeId;
      this.configuredFeeForSelection.applicationCategoryID = this.selectedApplicationCategoryId;
      this.configuredFeeForSelection.facilityCategoryID = this.selectedFacilityCategoryId;
      this.configuredFeeForSelection.changeTypeRefID = this.selectedChangeTypeRefId;
      this.configuredFeeForSelection.withinRegion = false;
      this.configuredFeeForSelection.fee = fee.value;
      this.settingsService.configureFeeForSelection(this.configuredFeeForSelection).subscribe(
        res => {
          if (res){
            this.alertService.success('Fee info added successfully');
          }else {
            this.alertService.error('Adding Fee info failed');
          }

        }, err => {
          this.alertService.error('Adding Fee info failed');
        }
      );
    } else {
      this.configuredFeeForSelection.fee = fee.value;
      this.settingsService.updateFeeConfigurationForSelection(this.configuredFeeForSelection).subscribe(
        res => {
          if (res) {
            this.alertService.success('Fee info updated successfully');
          }else {
            this.alertService.error('Updating Fee info failed');
          }

        }, err => {
          this.alertService.error('Updating Fee info failed');
        }
      );
    }

  }

  getmLevels(): void {
    this.commonService.getMLevels().subscribe(mLevels => this.manufacturingLevels = mLevels);
  }

  getmRLevels(): void {
    this.commonService.getMRLevels().subscribe(mRLevels => {
        this.manufacturingRiskLevels = mRLevels;
      }
    );
  }
}
